import { inject, observer } from "mobx-react";
import React, { Component, Fragment } from 'react';
import './style.scss';
import EventHeader from "./eventHeader";
import List from "~/components/videoplayer/list";
import VideoPlayerWrapper from "~/components/videoplayer";
import Events from "./events";
import Progress from "./progress";

@inject('igStore', 'appStore')
@observer
class Ig extends Component {

  // componentWillUnmount() {
  //   this.props.igStore.close();
  // }

  selectTab = (t) => {
    this.props.igStore.setTab(t);
  };

  render() {
    const { tab, tabs } = this.props.igStore;
    const { showList } = this.props.igStore.video;
    const { sid } = this.props.igStore.game;

    return <div className="ig">
      {/* {showList ? <List/> : null} */}
      {
        tabs.length > 1 ?
          <div className="ig-tabs">
            {
              tabs.map(t => t.show ?
                <button
                  className={`ig-tabs__tab ${tab === t.name ? 'active' : ''}`}
                  onClick={() => this.selectTab(t.name)}
                  key={t.name}>
                  <i className={t.ico}/>
                </button> : null
              )
            }
          </div> : null
      }
      <div className={`ig-tab-content s-c-${sid}`}>
        {this.renderTabContent()}
      </div>
    </div>
  }

  renderTabContent() {
    const { tab } = this.props.igStore;
    switch (tab) {
      case 'video':
        return <VideoPlayerWrapper/>;
      case 'events':
        return <Fragment>
          <EventHeader/>
          <Events/>
          </Fragment>;
      case 'stats':
        return <Fragment>
          <EventHeader/>
          <Progress {...this.props}/>
          </Fragment>;
    }
  }
}

@inject('igStore')
@observer
class IgWrapper extends Component {
  onClose = () => {
    this.props.igStore.close();
  };

  render() {
    const { video, game, tab, toggleVideoList } = this.props.igStore;
    if (!game) return null;

    return <div className="ig-wrapper">
      <div
        className="ig-wrapper__header"
        // onDrag={ this.onDrag }
        // onDragEnd={ this.onDragEnd }
        // onDragStart={ this.onDragStart }
        // onTouchStart={ this.onDragStart }
        // onTouchMove={ this.onDrag }
        // onTouchEnd={ this.onDragEnd }
        // draggable
      >
        <span className="ig-wrapper__header_title">{window.getLang('BROADCAST')}</span>
        {/* {tab === 'video' ?
          <div className="ig-wrapper__header_action" onClick={toggleVideoList}><span className={`f-s-ico-arrow_buttom_1${ video.showList ? ' open' : '' }`}/>
          </div> : null
        } */}
        {/*<div className="ig-wrapper__header_action ig-wrapper__header_action--expand" onClick={toggleWide}>*/}
        {/*  <span className={`f-s-ico-${ wide ? 'rollup' : 'expand' }`}/>*/}
        {/*</div>*/}
        <div className="ig-wrapper__header_action ig-wrapper__header_action--close" onClick={this.onClose}>×</div>
      </div>
      <Ig/>
    </div>
  }
}

export default IgWrapper


// WEBPACK FOOTER //
// ./src/components/ig/index.js